import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'edcom-ui';
import styles from 'edcom-ui/components/Facets/Facets.module.less';
import facetStyles from 'edcom-ui/components/Facets/Facet.module.less';
import fListStyles from 'edcom-ui/components/Facets/FacetList.module.less';
import clsx from 'clsx';

export default function SelectedContentFacet({
  selected,
  unSelect,
  showOnlySelected,
  setShowOnlySelected,
}) {
  let plural = selected.length > 1 ? 's' : '';
  let filterDisplay = selected.length + ' selection' + plural;

  let facetViewDisplay = showOnlySelected
    ? 'View all'
    : 'View ' + filterDisplay;

  const iconName = selected ? 'cancel-circled' : null;
  const iconClass = selected ? styles.removeIcon : null;

  const classes = clsx(facetStyles.link, facetStyles.selection, {
    [facetStyles.selected]: selected,
  });

  return (
    <div className={clsx(styles.searchFilter)}>
      <ul className={clsx(fListStyles.facets, fListStyles.topLevel)}>
        <li className={facetStyles.facet}>
          <div className={classes} role="link" title="Un-selected" tabIndex="0">
            <Icon
              name={iconName}
              className={clsx(facetStyles.icon, iconClass)}
              onClick={() => {
                unSelect([]);
              }}
            />
            {selected.length} selected
          </div>
        </li>
        <li className={facetStyles.facet}>
          <a
            className="Facet-module_link"
            onClick={() => setShowOnlySelected(!showOnlySelected)}
          >
            {facetViewDisplay}
          </a>
        </li>
      </ul>
    </div>
  );
}

SelectedContentFacet.propTypes = {
  selected: PropTypes.array,
  unSelect: PropTypes.func,
  showOnlySelected: PropTypes.bool,
  setShowOnlySelected: PropTypes.func,
};
